import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class IndexOutOfBoundsException extends Exception {
}
IndexOutOfBoundsException.kind = 'IndexOutOfBoundsException';
export default IndexOutOfBoundsException;
